//* 视图组件
import ViewModel from "../views/model/index.vue";
import ViewExample from "../views/example/index.vue";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();

    //* 静态数据
    const vars = {
        views: [
            { value: "model", label: i18n.t("DGPredictionTag"), component: ViewModel },
            { value: "example", label: i18n.t("ExampleData", 3), component: ViewExample },
        ],
    };

    //* 响应式数据
    const refs = {
        mode: ref<string>("model"),
    };

    //* 静态数据
    const computeds = {
        view: computed(() => {
            return vars.views.find((value) => value.value == refs.mode.value)?.component || ViewModel;
        }),
    };

    return { vars, refs, computeds };
};
